/** 白名单余额 */
<template>
  <div class="home black-list-home">
    <Layout
      type="HOME"
      pageTitle="供给方管理"
      titleSrc="/menu/homeIcon_black.png"
    >
      <BasiceLayout
        title="白名单及实时余额"
        class="bonus-code-layout"
      >
        <main>
          <el-table
          :data="list"
          width="200"
          >
          <el-table-column
            prop="email"
            label="邮箱"
            >
          </el-table-column>
          <el-table-column
            prop="balance"
            label="余额"
            >
          </el-table-column>
        </el-table>
        </main>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { log } from "util";
import { Message } from "element-ui";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import Layout from "@/components/CRM/Layout.vue";

export default {
  name: "home",
  data() {
    return {
      list: []
    };
  },
  computed: mapState({
  }),
  components: {
    Layout,
    BasiceLayout
  },
  methods: {
    ...mapActions(["getWhiteBalance"]),   
  },
  created() {
    this.getWhiteBalance().then(res => {
      this.list = res.data;
    });
  }
};
</script>

<style  lang="stylus">
.node-dial-content {
  width: 80%;
}

.crm-node-content{
  padding-top: 80px;
  height: auto;
  margin: 0 auto;
  background: #fff;
  padding: 20px;
  text-align: left;
}
</style>
